import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { eventLogger } from 'services/eventLogger.service'
import {
  selectAbSegmentName,
  selectOptimizeExperimentMap,
  selectOptimizeMap,
  selectOptimizeVariantMap,
} from 'root-redux/selects/common'
import {
  EXPERIMENT_ID_NOT_SET,
  NO_AB_SEGMENT_NAME,
  NO_TEST_OPTIMIZE_VARIANT,
} from 'root-constants'

export const useAbSegmentName = (): void => {
  const optimizeMap = useSelector(selectOptimizeMap)
  const abSegmentName = useSelector(selectAbSegmentName)
  const optimizeExperimentMap = useSelector(selectOptimizeExperimentMap)
  const optimizeVariantMap = useSelector(selectOptimizeVariantMap)

  useEffect(() => {
    if (!optimizeExperimentMap || !optimizeVariantMap) {
      eventLogger.logAbSegmentName({
        optimizeVariantId: NO_TEST_OPTIMIZE_VARIANT,
        optimizeExperimentId: EXPERIMENT_ID_NOT_SET,
        abSegmentName: abSegmentName || NO_AB_SEGMENT_NAME,
        optimizeMap: null,
      })
      return
    }

    Object.entries(optimizeVariantMap).forEach(
      ([optimizeExperimentId, optimizeVariantId]) => {
        eventLogger.logAbSegmentName({
          optimizeVariantId,
          optimizeExperimentId,
          abSegmentName,
          optimizeMap,
        })
      },
    )
  }, [abSegmentName, optimizeExperimentMap, optimizeVariantMap, optimizeMap])
}
